import React from "react";
import { Box, Divider, Grid, Paper, Skeleton } from "@mui/material";

const height = "70px";
const width = "100%";

const CampaignPageSkeleton = () => {
  return (
    <>
      {" "}
      <Paper
        sx={{
          p: 2,
          mb: 2,
        }}
        variant="outlined"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              flexGrow: 1,
              alignItems: "center",
            }}
          >
            <Skeleton
              animation="wave"
              variant="text"
              width="150px"
              height="40px"
            />
          </Box>
        </Box>

        <Box sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Skeleton
                animation="wave"
                variant="text"
                width={width}
                height={height}
              />
            </Grid>
            <Grid item xs={6}>
              <Skeleton
                animation="wave"
                variant="text"
                width={width}
                height={height}
              />
            </Grid>
            <Grid item xs={6}>
              <Skeleton
                animation="wave"
                variant="text"
                width={width}
                height={height}
              />
            </Grid>
            <Grid item xs={6}>
              <Skeleton
                animation="wave"
                variant="text"
                width={width}
                height={height}
              />
            </Grid>
            <Grid item xs={6}>
              <Skeleton
                animation="wave"
                variant="text"
                width={width}
                height={height}
              />
            </Grid>
            <Grid item xs={6}>
              <Skeleton
                animation="wave"
                variant="text"
                width={width}
                height={height}
              />
            </Grid>
            <Grid item xs={6}>
              <Skeleton
                animation="wave"
                variant="text"
                width={width}
                height={height}
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Skeleton
              animation="wave"
              variant="text"
              width="100px"
              sx={{ mr: 1 }}
            />
            <Skeleton
              animation="wave"
              variant="text"
              width="120px"
              height={height}
            />
          </Box>
        </Box>
      </Paper>
      <Paper
        sx={{
          py: 1,
          px: 2,
          mb: 2,
        }}
        variant="outlined"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              flexGrow: 1,
              alignItems: "center",
            }}
          >
            <Skeleton
              animation="wave"
              variant="text"
              width="150px"
              height="40px"
            />
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default CampaignPageSkeleton;
